<template>
  <div>
    <div>
      <div class="dis-flex js-center head wp-100">
        <div v-if="loginIn" class="js-between size-lf">
          <div class="font-set-1">肥东县农村卫生厕所</div>
          <div class="font-set-2">智能化长效管护平台</div>
          <el-button v-if="!userInfo" class="login-btn" type="primary" @click="loginIn = !loginIn">登录</el-button>
        </div>
        <div v-else class="js-between size-lf">
          <div class="font-set-1">肥东县农村卫生厕所</div>
          <div class="font-set-2">智能化长效管护平台</div>
          <el-form :model="dataForm" status-icon :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm" style="margin-top: 15px;">
            <el-form-item prop="account">
              <el-input v-model="dataForm.account" placeholder="请输入账号" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="pwd">
              <el-input type="password" v-model="dataForm.pwd" placeholder="请输入密码" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <el-button class="login-btn-w" type="primary" @click="toLogin">登录</el-button>
        </div>
        <div class="dis-flex align-center js-between size-rt">
          <img width="100%" height="100%" src="../../assets/image/index/menhu.jpg">
        </div>
      </div>
    </div>
    <div>
      <div class="dis-flex js-center head wp-100">
        <div class="js-between main-width">
          <el-menu :default-active="'11'" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="11">
              <span class="sub-title">村管理员排行</span>
            </el-menu-item>
          </el-menu>
          <div v-for="(item, index) in rankList" :class="(index==0 || index==5)?'rank-item0':'rank-item'">
<!--            <img width="228px" height="228px" :src="item.url?item.url:tempImg">-->
            <div class="rank-content0">{{item.ssqhmc}}</div>
            <div class="rank-text">第{{index+1}}名</div>
            <img style="margin-top: 15px;" width="120px" :src="rankImg(index)">
            <div class="rank-content1">{{item.xm}}</div>
            <div v-if="phbType==='0'" class="rank-content2">报抽次数：<span style="color: red;">{{item.bc?item.bc:0}}</span></div>
            <div v-if="phbType==='1'" class="rank-content2">报修次数：<span style="color: red;">{{item.bx?item.bx:0}}</span></div>
          </div>
        </div>
      </div>

      <div class="dis-flex js-center head wp-100">
        <div class="js-between main-width">
          <el-menu :default-active="'11'" style="width: 1160px;" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="11">
              <span class="sub-title" @click="clickLanmuMore('/noticeJs')">通知公告</span>
            </el-menu-item>
          </el-menu>
          <div class="more-link-right" @click="clickLanmuMore('/noticeJs')">更多></div>
          <div v-for="(item, index) in noticeList" :class="(index==0)?'notice-item0':'notice-item'">
            <div class="h-60 notice-title" :style="noticeTitleStyle(index)"  @click="clickContentMore('/noticeJs', item.tgcTztg.uuid)">{{item.tgcTztg.title}}</div>
            <div class="remark-content">{{item.tgcTztg.nr}}</div>
            <div v-for="child in item.listTTGcTztgDetails" style="cursor: pointer;" @click="clickNoticeContent('/noticeJs', item.tgcTztg.uuid)">
              <div class="remark-sub">{{child.title}}</div>
              <div class="remark-sub-content">{{child.nr}}</div>
              <div style="width: 280px; height: 17px; border-bottom: 1px solid #E6E6E6;"></div>
            </div>
<!--            <div class="more-link" @click="clickContentMore('/noticeJs', item.tgcTztg.uuid)">更多></div>-->
          </div>
        </div>
      </div>
      <div class="dis-flex js-center head wp-100" style="margin-top: 100px; background: #181C1F;border-bottom: 1px solid #272F33">
        <div class="js-between main-width">
          <div class="footer-space">
<!--            <img class="footer-img" height="30px" width="126px" src="../../assets/image/index/logo_1@2x.png">-->
            <div class="footer-title" style="margin-top: 70px;">联系我们</div>
            <p class="footer-txt">安徽省合肥市肥东县人民政府</p>
            <p class="footer-txt">安徽省合肥市肥东县农业农村局</p>
            <p class="footer-txt">电话：0551-67716585</p>
          </div>
          <div class="footer-space">
            <div class="footer-title" style="text-align: center;">相关站点</div>
            <p class="footer-txt" style="text-align: center;cursor: pointer;" @click="goToWeb('1')">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;肥东县人民政府门户</p>
            <p class="footer-txt" style="text-align: center;cursor: pointer;" @click="goToWeb('2')">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;肥东县农业农村局政务公开</p>
          </div>
          <div class="footer-space">
            <div class="footer-title" style="text-align: right; padding-right: 50px;">主办单位</div>
            <p class="footer-txt" style="text-align: right; padding-right: 17px;">肥东县人民政府</p>
            <p class="footer-txt" style="text-align: right;">肥东县农业农村局</p>
          </div>
        </div>
      </div>
<!--      <div class="footer-content">皖公网安备：34012202340137DSFJB</div>-->
    </div>
  </div>
</template>

<script>
    import { mapMutations } from 'vuex'
    export default {
        name: "ControlIndex",
        components: {
        },
        data () {
            return {
                tempList: [],
                tempImg: require('@/assets/image/index/temp_head_1.png'),
                rankImg1: require('@/assets/image/index/jiangbei1.png'),
                rankImg2: require('@/assets/image/index/jiangbei2.png'),
                rankImg3: require('@/assets/image/index/jiangbei3.png'),
                rankImg4: require('@/assets/image/index/jiangbei4.png'),
                loginIn: true,
                userInfo: localStorage.getItem('gcUserInfo')?localStorage.getItem('gcUserInfo'):'',
                rankList: [],
                noticeList: [],
                dataForm: {
                    account: '',
                    pwd: ''
                },
                rules: {
                    account:[{required: true, message: '请输入账号', trigger: 'blur'}],
                    pwd: [{required: true, message: '请输入密码', trigger: 'blur'}]
                },
                indexLoading: null,
                phbType: ''
            }
        },
        created() {
            let _this = this;
            document.onkeydown = function (e) {
                let key = window.event.keyCode;
                if (key === 13){
                    _this.toLogin();//方法
                }
            }
        },
        mounted() {
            this.getRanklist()
            this.getNoticeList()
            if (localStorage.getItem('gcUserInfo')) {
                this.getTreeByCode(JSON.parse(localStorage.getItem('gcUserInfo')).ssqhdm)
                this.getUserTreeByCode()
            }
        },
        methods: {
            toLogin: function () {
                let _this = this;
                // this.$router.push('/login')
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        _this.submitForm()
                    }
                })
            },
            // <!--提交登录-->
            submitForm: function () {
                this.indexLoading = this.$loading({
                    lock: true,
                    text: '用户验证中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                // 登录
                let _this = this
                let params = {}
                params.account = this.dataForm.account
                // params.pwd = this.dataForm.pwd
                params.pwd = this.$md5(encodeURIComponent(this.dataForm.pwd))
                _this.loading = true
                let param = {
                    info: params,
                    baseService: 'TGcUserServiceImpl',
                    type: 'login',
                }
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        _this.loading = false;
                        if (resultData.code == '200') {
                            localStorage.setItem('gcUserInfo', JSON.stringify(resultData.obj.user))
                            _this.userInfo = resultData.obj.user
                            setTimeout(function () {
                                _this.getMenuList(resultData.obj.user.yhqx)
                            }, 100)
                            _this.getAreaData()
                            // setTimeout(function () {
                            //     _this.getTreeByCode(resultData.obj.user.ssqhdm)
                            // })
                            _this.getRoleData()
                        } else {
                            _this.indexLoading.close()
                            _this.$message({
                                showClose: true,
                                message: resultData.errorMsg,
                                type: 'warning'
                            })
                        }
                    },
                    () => {
                        _this.loading = false
                        _this.indexLoading.close()
                        _this.$message({
                            showClose: true,
                            message: '请求异常，请联系管理员～',
                            type: 'error'
                        })
                    }
                )
            },
            // 根据登录人角色 获取权限菜单
            getMenuList(id) {
                let _this = this;
                let param = {
                    baseService: _this.GLOBAL.config.baseServiceType.TGcRoleServiceImpl,
                    type: 'findRole',
                    info: {
                        Personnel: {
                            yhqxid: id
                        }
                    }
                }
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        if (resultData) {
                            localStorage.setItem('menuList', JSON.stringify(resultData.obj.menus))
                            _this.indexLoading.close()
                            _this.loginIn = true
                            window.location.reload()
                        } else {

                        }
                    },err => {
                        console.log(err)
                        _this.$message.error('用户菜单获取失败～请联系管理员')
                        _this.indexLoading.close()
                    }
                )
            },
            // 获取通知乡镇区划
            getAreaData() {
                let _this = this;
                let param = {
                    baseService: 'TGcOrganizationServiceImpl',
                    type: 'getAll'
                }
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        if (resultData) {
                            localStorage.setItem('noticeDetailsTree', JSON.stringify(resultData.obj))
                            console.log(JSON.parse(localStorage.getItem('noticeDetailsTree')));
                        } else {
                            _this.$message.error('获取乡镇区划失败！')
                        }
                    }
                )
            },
            // 根据登录人code 获取区划树(县级显示全部 乡镇显示所属乡镇下的)
            getTreeByCode(code) {
                let _this = this;
              let data =  JSON.parse(localStorage.getItem(_this.GLOBAL.config.orgTreeName))
              if(data&&data.length>0){
                  return
              }
                let tempLoading = this.$loading({
                  lock: true,
                  text: '基础数据获取中...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                })
                let param = {
                    baseService: _this.GLOBAL.config.baseServiceType.TGcOrganizationServiceImpl,
                    type: 'getTreeCode',
                    info: code
                }
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        tempLoading.close()
                        if (resultData) {
                            localStorage.setItem(_this.GLOBAL.config.orgTreeName, JSON.stringify(resultData.obj))
                        } else {

                        }
                    },err => {
                        tempLoading.close()
                        console.log(err)
                    }
                )
            },
            getUserTreeByCode() {

                let _this = this;
                let param = {
                    baseService: 'TGcOrganizationServiceImpl',
                    type: 'getTree'
                }
                if (JSON.parse(unescape(localStorage.getItem("gcUserInfo"))).ssqhdm !== '340122000000') {
                    param.info = JSON.parse(unescape(localStorage.getItem("gcUserInfo"))).ssqhdm;
                    param.type = "getTreeCode";
                }
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        if (resultData) {
                            // _this.options = resultData.obj;
                            localStorage.setItem('treeDic', JSON.stringify(resultData.obj))
                            // _this.formData.gxqy =  _this.FUNCTIONS.systemFunction.returnArea('340122100001,340122100002,340122100003', _this.options)
                        } else {

                        }
                    }
                )
            },
            rankImg: function (i) {
                if (i == 0) {
                    return this.rankImg1
                } else if (i == 1) {
                    return this.rankImg2
                } else if (i == 2) {
                    return this.rankImg3
                } else {
                    return this.rankImg4
                }
            },
            noticeTitleStyle: function (i) {
                if (i == 0) {
                    return 'background: #5872E0;cursor: pointer;'
                } else if (i == 1) {
                    return 'background: #E16A79;cursor: pointer;'
                } else if (i == 2) {
                    return 'background: #FA9184;cursor: pointer;'
                } else {
                    return 'background: #6CAC9D;cursor: pointer;'
                }
            },
            // 跳转县政府门户
            goToWeb: function (type) {
                let url = ''
                if (type === '1') {
                    url = 'http://www.feidong.gov.cn/'
                } else if (type === '2') {
                    url = 'http://zwgk.hefei.gov.cn/public/column/18051?type=2'
                }
                open(url, '_blank')
            },
            // 通知公告-栏目更多
            clickLanmuMore: function (path) {
                this.isLogin(path)
            },
            // 通知公告-详情更多
            clickContentMore: function (path, data) {
                this.isLogin(path, data)
            },
            // 通知公告-栏目点击
            clickNoticeLanmu: function (path, data) {
                this.isLogin(path, data)
            },
            // 通知公告-详情点击
            clickNoticeContent: function (path, data) {
                this.isLogin(path, data)
            },
            // 判断是否登录
            isLogin: function (path, data) {
                let userInfo = localStorage.getItem('gcUserInfo')
                if (!userInfo) {
                    this.$message.warning('请登录后查看！')
                    // this.$router.push({path: '/login'})
                } else {
                    this.$router.push({path: path, query: {uuid: data}})
                }
            },
            // 请求村管理员排行数据
            getRanklist: function () {
                let _this = this
                let param = {
                    baseService: _this.GLOBAL.config.baseServiceType.TGcBcxxServiceImpl
                }
                _this.FUNCTIONS.systemFunction.interactiveData(
                    _this,
                    _this.GLOBAL.config.businessFlag.zxUser,
                    _this.GLOBAL.config.handleType.jobInfo,
                    param,
                    null,
                    resultData => {
                        _this.loading = false
                        if (resultData.code === '200') {
                            // 结果参数赋值
                            _this.phbType = resultData.obj.type
                            if (resultData.obj.type === '0') {
                                // 报抽
                                _this.rankList = resultData.obj.bc
                            } else {
                                // 报修
                                _this.rankList = resultData.obj.bx
                            }
                        } else {
                            _this.$message.warning('获取排行榜数据失败～')
                        }
                    },
                    () => {
                        _this.loading = false
                    }
                )
            },
            // 请求通知公告信息
            getNoticeList: function () {
                let _this = this
                // let searchParams = this.searchForm

                let param = {
                    baseService: _this.GLOBAL.config.baseServiceType.TGcTztgServiceImpl
                }
                _this.FUNCTIONS.systemFunction.interactiveData(
                    _this,
                    _this.GLOBAL.config.businessFlag.zxUser,
                    _this.GLOBAL.config.handleType.getInform,
                    param,
                    null,
                    resultData => {
                        _this.loading = false
                        if (resultData.code === '200') {
                            // 结果参数赋值
                            _this.noticeList = resultData.obj
                        } else {
                            _this.$message.warning('获取通知公告数据失败～')
                        }
                    },
                    () => {
                        _this.loading = false
                    }
                )
            },
            getRoleData() {
                let _this = this;
                let param = {
                    baseService: 'TGcRoleServiceImpl',
                    type: 'getNewAll',
                    info: JSON.parse(localStorage.getItem('gcUserInfo')).ssqhdm
                }
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        if (resultData) {
                            localStorage.setItem('noticeRoles', JSON.stringify(resultData.obj))
                        } else {
                            _this.$message.error('获取角色数据失败！')
                        }
                    }
                )
            }
        }
    }
</script>

<style scoped>
  .dis-flex{
    display: flex;
  }
  .js-center{
    justify-content: center;
  }
  .head{
    top: 0;
    left: 0;
    z-index: 19;
    font-family: SimHei;;
  }
  .wp-100{
    width: 100%;
  }
  .js-between{
    justify-content: space-between;
  }
  .align-center{
    align-items: center;
  }
  .menu-list{
    text-align: center;
    width: 120px;
    color: #333333;
    font-size: 16px;
  }
  .index-login{
    width: 400px;
    height: 145px;
  }
  .index-img{
    width: 800px;
    height: 145px;
  }
  .main-width{
    width: 1200px;
  }
  .size-lf{
    width: 400px;
    height: 290px;
  }
  .size-rt{
    width: 800px;
    height: 290px;
  }
  .font-set-1{
    color: #2B68E4;
    font-size: 42px;
    text-align: left;
    padding-top: 20px;
  }
  .font-set-2{
    color: #2B68E4;
    font-size: 34px;
    text-align: left;
    padding-top: 30px;
  }
  .login-btn{
    margin-top: 50px;
    float: left;
  }
  .login-btn-w{
    margin-top: -60px;
    margin-right: 40px;
    float: right;
  }
  .sub-title{
    color: #1A1A1A;
    font-size: 30px;
  }
  .rank-item0{
    width: 228px;
    height: 300px;
    margin-top: 15px;
    display: inline-block;
    border: 1px solid #e5e5e5;
    text-align: center;
  }
  .rank-item{
    width: 228px;
    height: 300px;
    margin-top: 15px;
    margin-left: 12px;
    display: inline-block;
    border: 1px solid #e5e5e5;
    text-align: center;
  }
  .rank-text{
    text-align: center;
    font-size: 18px;
    line-height: 20px;
    margin-top: 15px;
  }
  .rank-content0{
    height: 60px;
    width: 228px;
    text-align: center;
    line-height: 60px;
    font-size: 20px;
    background: #E16A79;
    color: #fff;
  }
  .rank-content1{
    color: #4D4D4D;
    font-size: 14px;
    text-align: left;
    padding-top: 5px;
    text-align: center;
    margin-top: 10px;
  }
  .rank-content2{
    color: #808080;
    font-size: 18px;
    text-align: left;
    padding-top: 5px;
    text-align: center;
  }
  .notice-item0{
    width: 280px;
    height: 360px;
    margin-top: 20px;
    display: inline-block;
    float: left;
  }
  .notice-item{
    width: 280px;
    height: 360px;
    margin-top: 20px;
    margin-left: 26px;
    display: inline-block;
    float: left;
  }
  .notice-title{
    width: 260px;
    color: #FFFFFF;
    font-size: 20px;
    line-height: 60px;
    text-align: left;
    padding-left: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .h-60{
    height: 60px;
  }
  .remark-content{
    width: 240px;
    background: #F6F6F6;
    color: #808080;
    font-size: 12px;
    line-height: 24px;
    height: 42px;
    padding: 6px 20px 6px 20px;
    white-space:normal;
    word-break:break-all;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .remark-sub{
    width: 280px;
    color: #333333;
    font-size: 16px;
    line-height: 56px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .remark-sub-content{
    width: 280px;
    color: #808080;
    font-size: 14px;
    line-height: 18px;
    white-space:normal;
    word-break:break-all;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .more-link{
    color: #2B68E4;
    font-size: 14px;
    padding: 18px 0 36px;
    float: left;
    cursor: pointer;
  }
  .more-link-right{
    color: #2B68E4;
    font-size: 14px;
    float: right;
    width: 40px;
    cursor: pointer;
    margin-top: -20px;
  }
  .el-footer{
    background-color: #181C1F;
    height: 230px !important;
  }
  .footer-space{
    width: 400px;
    height: 150px;
    text-align: left;
    display: table-cell;
  }
  .footer-content{
    background: #181C1F;
    color: #B3B3B3;
    font-size: 14px;
    line-height: 54px;
  }
  .footer-img{
    margin-top: 70px;
  }
  .footer-txt{
    color: #B3B3B3;
    margin-top: 18px;
  }
  .footer-title{
    color: #ffffff;
    font-size: 20px;
  }
  .account-space{
    cursor: pointer;
    color: #2B68E4;
  }
</style>



// WEBPACK FOOTER //
// src/view/ControlIndex/index.vue